export default "/fonts/vendor/@quasar/extras/fontawesome-v6/fa-regular-400.woff2?89999bdf5d835c0120257222e5568fec";